import { render, staticRenderFns } from "./ownerContractInfo.vue?vue&type=template&id=74a287ab&scoped=true"
import script from "./ownerContractInfo.vue?vue&type=script&lang=js"
export * from "./ownerContractInfo.vue?vue&type=script&lang=js"
import style0 from "./ownerContractInfo.vue?vue&type=style&index=0&id=74a287ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a287ab",
  null
  
)

export default component.exports